import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ToastMessage {
  severity: string;
  summary: string;
  detail: string;
  life?: number;
  id?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private messageSubject = new Subject<ToastMessage>();
  readonly message$ = this.messageSubject.asObservable();

  private idCounter = 0;

  show(options: { severity: string; summary: string; detail: string; life?: number }): void {
    this.messageSubject.next({ ...options, id: ++this.idCounter });
  }
}
